import React, { useState } from "react";
import useStyles from "./styles";
import { Checkbox } from "Components/Form";
import { Box } from "@mui/material";
import CheckboxComponent from "Components/Form/CheckboxComponent/CheckboxComponent";
import { CheckboxGroup } from "Components/Form/CheckboxGroup";

import LabelForm from "Components/Form/Label";

export default function CheckboxSection() {
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});
  const [checked, setChecked] = useState<boolean>(false);
  const [checked1, setChecked1] = useState<boolean>(false);

  const classes = useStyles();

  const handleChangeCheckbox = (label: string, checked: boolean) => {
    setCheckedItems((prev) => ({
      ...prev,
      [label]: checked,
    }));
  };

  const checkboxOptions = ["Option 1", "Option 2", "Option 3"];

  return (
    <>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>Checkbox</LabelForm>
        </div>
        <Box className={classes.checkboxContainer}>
          {checkboxOptions.map((item) => (
            <Checkbox
              key={item}
              label={item}
              checked={checkedItems[item] || false}
              onChange={(_, checked) => {
                setCheckedItems((prev) => ({ ...prev, [item]: checked }));
              }}
            />
          ))}
        </Box>
        <hr />
      </div>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>CheckboxComponent</LabelForm>
        </div>
        <Box>
          {checkboxOptions.map((item) => (
            <CheckboxComponent
              key={item}
              onChange={(_, checked) => handleChangeCheckbox(item, checked)}
              checked={checkedItems[item]}
              label={item}
            />
          ))}
        </Box>
        <hr />
      </div>
      <div>
        <CheckboxGroup
          label="CheckboxGroup"
          required
          options={[
            {
              label: "label 1",
              value: checked,
              onChange() {
                setChecked(!checked);
              },
            },
            {
              label: "label 2",
              value: checked1,
              onChange() {
                setChecked1(!checked1);
              },
            },
          ]}
          className={classes.checkboxGroup}
        />
        <hr />
      </div>
    </>
  );
}
